import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyImport, LazyAction } from 'owa-bundling';

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "Popout" */ './lazyIndex'),
    { name: 'Popout' }
);

export const lazyBootPopout: LazyImport<typeof lazyIndex.bootPopout, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.bootPopout);
export const lazyClosePopout: LazyAction<typeof lazyIndex.closePopout, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.closePopout);
export const lazyWaitForProjectionUpdate: LazyImport<
    typeof lazyIndex.waitForProjectionUpdate,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.waitForProjectionUpdate);
export const lazyTrackPopoutWindow: LazyAction<
    typeof lazyIndex.trackPopoutWindow,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.trackPopoutWindow);
export const lazySavePopoutWindowGeometry: LazyImport<
    typeof lazyIndex.savePopoutWindowGeometry,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.savePopoutWindowGeometry);
